module.exports = __webpack_public_path__ + "google-home2.41162704e1e7e0e84e1f.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/pkwoy/Desktop/progressive-webb-app/src/assets/img/google-home2.jpg
// module id = ../../../../../src/assets/img/google-home2.jpg
// module chunks = styles